import { LimitedFeature } from '../types';

/**
 * Titles for the redesigned trial paywall ("Unlock <Feature> and more", Figma 3-Pricing 6161:4507).
 * Shown instead of the old per-feature upsell banner when a TRIAL user hits a gated feature.
 */
export const TRIAL_PAYWALL_TITLES: Partial<Record<LimitedFeature, string>> = {
  audioDownload: 'Unlock Audio Export and more',
  glossary: 'Unlock Glossary and more',
  lipSync: 'Unlock Lip-sync and more',
  multilanguage: 'Unlock Multi-language and more',
  srtDownload: 'Unlock SRT Export and more',
  srtUpload: 'Unlock SRT Upload and more',
  subtitleExport: 'Unlock Subtitle export and more',
  teamspace: 'Unlock Teamspaces and more',
  translationDictionary: 'Unlock Dictionary and more',
  translationTone: 'Unlock Prompting and more',
  unlimitedLength: 'Unlock Unlimited Length and more',
  userPrompting: 'Unlock Translation Prompting and more',
  videoSubtitles: 'Unlock Video Subtitles and more',
  voicePresets: 'Unlock Voice Presets and more',
};
